import { useEffect, useState } from "react";
import {
  connectWallet,
  getCurrentWalletConnected,
  mintNFT//import here} from "./utils/interact.js";
} from "./utils/interact.js";
import FrostBlade from 'D:/NFT_development/front_end/relics_minter/nft-minter-tutorial-main/minter-starter-files/src/CursedCauldron.gif'

const Minter = (props) => {

  

  function addWalletListener() {
  if (window.ethereum) {
    window.ethereum.on("accountsChanged", (accounts) => {
      if (accounts.length > 0) {
        setWallet(accounts[0]);
        setStatus("👆🏽 Write a message in the text-field above.");
      } else {
        setWallet("");
        setStatus("🦊 Connect to Metamask using the top button.");
      }
    });
  } else {
    setStatus(
      <p>
        {" "}
        🦊{" "}
        <a target="_blank" href={`https://metamask.io/download.html`}>
          You must install Metamask, a virtual Ethereum wallet, in your
          browser.
        </a>
      </p>
    );
    }
  }

  //State variables
  const [walletAddress, setWallet] = useState("");
  const [status, setStatus] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [url, setURL] = useState("");
 
  useEffect(async () => { //TODO: implement
    const {address, status} = await getCurrentWalletConnected();
    setWallet(address)
    setStatus(status);
    
        
    addWalletListener(); 
  }, []);

  const connectWalletPressed = async () => { //TODO: implement
    const walletResponse = await connectWallet();
    setStatus(walletResponse.status);
    setWallet(walletResponse.address);
  };

  const onMintPressed = async () => { //TODO: implement
      const { status } = await mintNFT();
    setStatus(status);  
  };

  return (
    <div className="Minter">
      <button id="walletButton" onClick={connectWalletPressed}>
        {walletAddress.length > 0 ? (
          "Connected: " +
          String(walletAddress).substring(0, 6) +
          "..." +
          String(walletAddress).substring(38)
        ) : (
          <span>Connect Wallet</span>
        )}
      </button>

      <br></br>
      <h1 id="title">Relics of the PixaVerse!</h1>
      <h2 id="title">Connect your wallet and mint your Relic below!</h2>

      <br></br>

      <h2 id="title">Relic #3: The Cursed Cauldron.</h2>
      <div>
      <img src={FrostBlade} alt="Image" height={300} width={300}/>
      </div>

      <p>
       
      </p>
      
      <button id="mintButton" onClick={onMintPressed}>
        Mint!
      </button>
      <p id="status">
        {status}
      </p>
      <h3 id="title">Claim period ends Monday October 18th.</h3>

      <br></br>
    </div>
  );
};



export default Minter;
